// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"6e0555642fbf3142d935","678":"eb320acb11c39f8dec3e","883":"8b144762e79cdce64021"}[chunkId] + ".js";
};